import { Grid } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { Amount } from "../../../../components/amount";
import { ListTable } from "../../../../components/list_table";
import { IAsyncData } from "../../../../core/models";
import { total } from "../../../../core/utils";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { IClientHistory } from "../../data/entities";
import { clientHistoryReduxActions } from "../state/state";

export const ClientHistoryList: React.FC = () => {
  const dispatch = useDispatch();
  const { search } = useLocation();

  useEffect(() => {
    dispatch(clientHistoryReduxActions.getHistoryList(search));
  }, [dispatch, search]);
  const clientHistoryListBranch = useSelector<IAppReduxState, IAsyncData<IClientHistory[]>>(
    (state) => state.clientHistory.historyList,
  );
  const clientsWithDebt = clientHistoryListBranch.data?.filter((c) => c.balanceAfter < 0) ?? [];
  const clientsWithoutDebt = clientHistoryListBranch.data?.filter((c) => c.balanceAfter >= 0) ?? [];

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item sm={12} md={6}>
          <ListTable<IClientHistory>
            branch={clientsWithDebt}
            route={ROUTES.client}
            renderHeader={() => (
              <>
                <TableCell>Ad</TableCell>
                <TableCell>Balans</TableCell>
              </>
            )}
            renderRow={(client) => (
              <>
                <TableCell>{client.client.name}</TableCell>
                <TableCell>
                  <Amount amount={client.balanceAfter} />
                </TableCell>
              </>
            )}
            renderSummary={() => {
              const t = total(clientsWithDebt, (ch) => ch.balanceAfter);

              return (
                <>
                  <TableCell colSpan={2}>Toplam</TableCell>
                  <TableCell colSpan={3}>
                    <Amount amount={t} />
                  </TableCell>
                </>
              );
            }}
          />
        </Grid>

        <Grid item sm={12} md={6}>
          <ListTable<IClientHistory>
            branch={clientsWithoutDebt}
            route={ROUTES.client}
            renderHeader={() => (
              <>
                <TableCell>Ad</TableCell>
                <TableCell>Balans</TableCell>
              </>
            )}
            renderRow={(client) => (
              <>
                <TableCell>{client.client.name}</TableCell>
                <TableCell>
                  <Amount amount={client.balanceAfter} />
                </TableCell>
              </>
            )}
            renderSummary={() => {
              const t = total(clientsWithoutDebt, (ch) => ch.balanceAfter);

              return (
                <>
                  <TableCell colSpan={2}>Toplam</TableCell>
                  <TableCell colSpan={3}>
                    <Amount amount={t} />
                  </TableCell>
                </>
              );
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};
